import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Home from '@/components/home'
// import Access from '@/components/access'
import Login from '@/components/login'
import Profile from '@/components/profile'
import Dashboard from '@/components/dashboard'
import Module from '@/components/module'
import Assessment from '@/components/module/assessment'
import Certificate from '@/components/module/certificate'
import Author from '@/components/author'

import Admin from '@/components/admin'
import AdminModule from '@/components/admin/module'

import VerifyEmail from '@/components/verify'
import PasswordReset from '@/components/passwords/reset'
import PrivacyPolicy from '@/components/footer/privacy'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/module/:id',
      name: 'Module',
      component: Module,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/module/:id/assessment',
      name: 'MandatoryAssessMent',
      component: Assessment,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/certificate/:code',
      name: 'Certificate',
      component: Certificate,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/author/:name',
      name: 'Author',
      component: Author
    },

    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/module/:id',
      name: 'Admin Module',
      component: AdminModule,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/verify/email/:token',
      name: 'Verify Email',
      component: VerifyEmail
    },
    {
      path: '/password/reset/:token',
      name: 'Password Reset',
      component: PasswordReset
    },
    {
      path: '/privacy/policy',
      name: 'policy',
      component: PrivacyPolicy
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js